import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import {
  Card, CardBody,
  Container, Row, Col, Spinner,
  Alert, Label, Input, Button,
  Form, FormFeedback
} from "reactstrap";
import * as Yup from "yup";
import { useFormik } from "formik";

import { ToastContainer } from "react-toastify";

import { loginUser } from "../../slices/thunks";

import ParticlesAuth from "./ParticlesAuth";
import withRouter from "../../Components/Common/withRouter";

const Login = (props) => {
  document.title = "Login | Sefer IMS";

  const dispatch = useDispatch();
  
  const [passwordShow, setPasswordShow] = useState(false);  

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      username: "",
      password: "",
    },
    validationSchema: Yup.object({
      username: Yup.string().required("Unesite svoje korisničko ime"),
      password: Yup.string().required("Unesite svoju šifru"),
    }),
    onSubmit: (values) => {
      dispatch(loginUser(values, props.router.navigate));
    },
  });

  return (
    <React.Fragment>
    <ToastContainer closeButton={false} limit={3} />
      <ParticlesAuth>
        <div className="auth-page-content">
          <Container>
            <Row>
              <Col lg={12}>
                <div className="text-center mt-sm-5 mb-4 text-white-50">
                  <div><Link to="/" className="d-inline-block auth-logo"></Link></div>
                  <p className="mt-3 fs-15 fw-medium"></p>
                </div>
              </Col>
            </Row>
            <Row className="justify-content-center">
              <Col md={8} lg={6} xl={5}>
                <Card className="mt-4">
                  <CardBody className="p-4">
                    <div className="text-center mt-2">
                      <h5 className="text-primary">Dobrodošli!</h5>
                    </div>
                    <div className="p-2 mt-4">
                      <Form onSubmit={(e) => {e.preventDefault(); validation.handleSubmit(); return false;}}>
                        <div className="mb-3">
                          <Label htmlFor="email" className="form-label"> Korisničko ime </Label>
                          <Input name="username" type="text" className="form-control"
                            placeholder="Unesite korisničko ime"                            
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.username || ""}
                            invalid={validation.touched.username && validation.errors.username ? true : false}
                          />
                          {validation.touched.username && validation.errors.username ? (<FormFeedback type="invalid">{validation.errors.username}</FormFeedback>) : null}
                        </div>
                        <div className="mb-3">                          
                          <Label htmlFor="password-input" className="form-label" > Šifra </Label>
                          <div className="position-relative auth-pass-inputgroup mb-3">
                            <Input name="password" type={passwordShow ? "text" : "password"} className="form-control pe-5"
                              placeholder="Unesite šifru"
                              value={validation.values.password || ""}
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              invalid={validation.touched.password && validation.errors.password ? true : false}
                            />
                            {validation.touched.password && validation.errors.password ? (<FormFeedback type="invalid">{validation.errors.password}</FormFeedback>) : null}
                            <Button id="password-addon" onClick={() => setPasswordShow(!passwordShow)} className="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted">
                              <i className="ri-eye-fill align-middle" />
                            </Button>
                          </div>
                        </div>
                        <div className="mt-4">
                          <Button color="success" type="submit" className="w-100" outline> Login </Button>
                        </div>
                      </Form>
                    </div>
                  </CardBody>
                </Card>               
              </Col>
            </Row>
          </Container>
        </div>
      </ParticlesAuth>
    </React.Fragment>
  );
};

export default withRouter(Login);
